import React from 'react';
import { Button } from '../../components/ui';

interface Props {
  email: string;
  accountName: string;
  onChange: (name: string) => void;
  onNext: () => void;
}

export const StepWelcome: React.FC<Props> = ({ email, accountName, onChange, onNext }) => {
  const [submitted, setSubmitted] = React.useState(false);
  const trimmed = accountName.trim();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    if (!trimmed) return;
    onNext();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5" aria-label="Welcome step">
      <div>
        <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-1">Your email</p>
        <p className="text-sm text-slate-800 font-mono bg-slate-50 border border-slate-200 rounded-md px-3 py-2">{email}</p>
      </div>
      <div className="space-y-1">
        <label htmlFor="account-name" className="block text-xs font-medium text-slate-700">
          Workspace / company name <span className="text-danger-600">*</span>
        </label>
        <input
          id="account-name"
          type="text"
          value={accountName}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Acme Inc."
          autoFocus
          maxLength={120}
          className="block w-full rounded-md border border-slate-300 px-3 py-2 text-sm placeholder:text-slate-400"
        />
        {submitted && !trimmed && (
          <p className="text-xs text-danger-700">Workspace name is required</p>
        )}
        <p className="text-xs text-slate-500">Usually your company or team name. You can change this later.</p>
      </div>
      <Button type="submit" variant="primary" size="md" className="w-full">Continue</Button>
    </form>
  );
};
